import { render, staticRenderFns } from "./SifrantKulturaItem.vue?vue&type=template&id=590e6126&"
import script from "./SifrantKulturaItem.vue?vue&type=script&lang=js&"
export * from "./SifrantKulturaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports